import axios from "../axiosInstance";
import { FetchWeekSummaryRequest, FetchWeekSummaryResponse } from "./types";

export const fetchWeekSummary = async (
  requestData: FetchWeekSummaryRequest,
): Promise<FetchWeekSummaryResponse> => {
  const response = await axios.get<FetchWeekSummaryResponse>(
    "/api/private/stochastic/campaign-billing/week-summary",
    {
      params: requestData,
    },
  );
  return response.data;
};
